module.exports = __webpack_public_path__ + "static/media/login_img.1d4895e2.png";